/* 14.10.2026: Streaming Royalty Calculator (sections/streaming-calculator.liquid), етап 1.2.
   Vanilla JS, без бібліотек. Повзунок у лог-шкалі 1K-10M (0..1000 позицій) синхронний з полем,
   живі суми (анімація rAF, поважає prefers-reduced-motion), одна відповідь по вибраному сервісу.
   Офери = посилання /discount/<код>?redirect=<шлях з UTM>; JS міняє href/текст головної кнопки під вибраний сервіс,
   шле calc_offer_click, prefetch кінцевої сторінки, лоадер і швидкий перехід (знижка фоновим fetch, див. нижче).
   Тултіп «?» (методологія): hover/focus через CSS, тап на мобайлі - клас is-open, закриття кліком поза ним / Esc.
   18.10.2026: повна аналітика calc_* (knowledge/ANALYTICS-TRACKING-MAP.md, розділ «Калькулятор роялті»):
   calc_view (показ, раз), calc_input (slider/число, debounce 1с), calc_quick_value (клік мітки 1K-10M),
   calc_service_select (клік рядка сервісу), calc_offer_click / calc_table_click / calc_sticky_cta (3 джерела
   одного класу .calc-offer-link, розрізняємо по data-source), calc_faq_open (акордеон #faq, лише ця сторінка),
   calc_guide_scroll (догортали до #guide). Сесійна атрибуція: markUsed пише sessionStorage ps_calc_user -
   layout/theme.liquid додає from_404-подібно from_calc=1 (GA4) і calc_user=1 (Clarity-тег) до КОЖНОЇ наступної
   події сесії (так само, як сесійна мітка 404), щоб бачити add_to_cart/purchase після калькулятора. */
(function () {
  var root = document.querySelector('[data-calc]');
  if (!root) return;

  var MIN = 1000, MAX = 10000000, STEPS = 1000;
  var LOG_SPAN = Math.log(MAX / MIN);
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var services = [];
  try { services = JSON.parse(root.querySelector('[data-calc-json]').textContent); } catch (e) { return; }
  if (!services.length) return;

  var input = root.querySelector('[data-calc-input]');
  var range = root.querySelector('[data-calc-range]');
  var shareSel = root.querySelector('[data-calc-share]');
  var resName = root.querySelector('[data-calc-result-name]');
  var resValue = root.querySelector('[data-calc-result-value]');
  var cta = root.querySelector('[data-calc-cta]');
  var ctaText = root.querySelector('[data-calc-cta-text]');
  var sticky = root.querySelector('[data-calc-sticky]');
  var stickyName = root.querySelector('[data-calc-sticky-name]');
  var stickyValue = root.querySelector('[data-calc-sticky-value]');
  var stickyBtn = root.querySelector('[data-calc-sticky-btn]');
  var resultBox = root.querySelector('[data-calc-result]');
  var offersBox = document.getElementById('calc-offers');

  var maxRate = 0;
  // масштаб смуг - без «другорядних» сервісів (Napster: рішення власника 14.10), їхня смуга обрізається до 100%
  services.forEach(function (s) { s.rate = parseFloat(s.rate) || 0; if (!s.minor && s.rate > maxRate) maxRate = s.rate; });

  var rows = {};
  root.querySelectorAll('[data-calc-row]').forEach(function (btn) {
    rows[btn.getAttribute('data-calc-row')] = {
      btn: btn,
      li: btn.parentNode,
      val: btn.querySelector('[data-calc-val]'),
      bar: btn.querySelector('[data-calc-bar]'),
      shown: 0
    };
  });

  var state = {
    streams: clamp(parseInt(root.getAttribute('data-default'), 10) || 10000),
    share: 1,
    key: root.getAttribute('data-default-key') || services[0].key,
    shownSel: 0,
    used: false
  };
  if (!find(state.key)) state.key = services[0].key;

  var fmtInt = new Intl.NumberFormat('en-US');
  var fmtUsd2 = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
  var fmtUsd0 = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
  function usd(v) { return v >= 10000 ? fmtUsd0.format(v) : fmtUsd2.format(v); }

  function clamp(v) { return Math.min(Math.max(v, MIN), 1000000000); }
  function find(key) { for (var i = 0; i < services.length; i++) if (services[i].key === key) return services[i]; return null; }
  function toPos(v) { return Math.round(Math.log(Math.min(Math.max(v, MIN), MAX) / MIN) / LOG_SPAN * STEPS); }
  function fromPos(p) {
    var v = MIN * Math.exp(p / STEPS * LOG_SPAN);
    // «круглі» значення на повзунку: 2 значущі цифри (12 000, 340 000)
    var mag = Math.pow(10, Math.floor(Math.log10(v)) - 1);
    return Math.round(v / mag) * mag;
  }
  function tpl(str, map) {
    return String(str || '').replace(/\[(\w+)\]/g, function (m, k) { return map[k] != null ? map[k] : m; });
  }
  // інлайн-число без рамки: ширина = довжина тексту
  function fitInput() {
    var v = String(input.value), commas = (v.match(/,/g) || []).length;
    input.style.width = Math.max(v.length - commas * 0.7, 2) + 0.1 + 'ch';
  }
  function earn(s) { return s.rate * state.streams * state.share; }

  // ---- анімація чисел (рядки + велика цифра відповіді) ----
  var raf = 0;
  function animate() {
    cancelAnimationFrame(raf);
    var from = {}, to = {};
    services.forEach(function (s) { if (rows[s.key]) { from[s.key] = rows[s.key].shown; to[s.key] = earn(s); } });
    var sel = find(state.key);
    var selFrom = state.shownSel, selTo = sel ? earn(sel) : 0;
    if (reduceMotion) { paint(to, selTo); return; }
    var t0 = performance.now(), dur = 380;
    (function step(now) {
      var t = Math.min((now - t0) / dur, 1);
      var e = 1 - Math.pow(1 - t, 3);
      var cur = {};
      Object.keys(to).forEach(function (k) { cur[k] = from[k] + (to[k] - from[k]) * e; });
      paint(cur, selFrom + (selTo - selFrom) * e);
      if (t < 1) raf = requestAnimationFrame(step);
    })(t0);
  }
  function paint(vals, selVal) {
    Object.keys(vals).forEach(function (k) { rows[k].shown = vals[k]; rows[k].val.textContent = usd(vals[k]); });
    state.shownSel = selVal;
    resValue.textContent = usd(selVal);
    if (stickyValue) stickyValue.textContent = usd(selVal);
  }

  // ---- рендер ----
  function render(fromRange) {
    var pos = toPos(state.streams) / STEPS;
    services.forEach(function (s) {
      var r = rows[s.key];
      // смуга = частка від найкращої ставки × позиція повзунка (смуги «ростуть» разом зі стрімами)
      if (r && r.bar) r.bar.style.transform = 'scaleX(' + (maxRate ? Math.min(s.rate / maxRate, 1) * (0.12 + 0.88 * pos) : 0).toFixed(4) + ')';
    });
    if (!fromRange) range.value = toPos(state.streams);
    range.style.setProperty('--fill', (range.value / STEPS * 100).toFixed(2) + '%');
    if (document.activeElement !== input) input.value = fmtInt.format(state.streams);
    fitInput();
    renderSelected();
    animate();
  }

  function renderSelected() {
    var s = find(state.key);
    if (!s) return;
    resName.textContent = s.name;
    if (stickyName) stickyName.textContent = s.name;
    ctaText.textContent = s.offerName ? tpl(root.getAttribute('data-cta'), { platform: s.offerName }) : root.getAttribute('data-cta-generic');
    cta.href = s.url;
    cta.setAttribute('data-platform', s.offer);
    if (stickyBtn) { stickyBtn.href = s.url; stickyBtn.setAttribute('data-platform', s.offer); }
    Object.keys(rows).forEach(function (k) {
      var on = k === state.key;
      rows[k].li.classList.toggle('is-active', on);
      rows[k].btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  // перша взаємодія з калькулятором за сесію - sessionStorage-мітка, щоб layout/theme.liquid
  // додав from_calc/calc_user до наступних подій (той самий патерн, що й ps_404)
  function markUsed(how) {
    if (state.used) return;
    state.used = true;
    try { sessionStorage.setItem('ps_calc_user', String(Date.now())); } catch (e) {}
  }

  // calc_input - debounce ~1с, щоб не спамити на кожен тик повзунка/символ вводу
  var inputTimer = 0;
  function trackInput() {
    clearTimeout(inputTimer);
    inputTimer = setTimeout(function () {
      window.psTrack && psTrack('calc_input', { streams: state.streams, service: state.key });
    }, 1000);
  }

  // ---- ввід ----
  range.addEventListener('input', function () {
    state.streams = fromPos(+range.value);
    markUsed('slider');
    render(true);
    trackInput();
  });
  input.addEventListener('input', function () {
    var digits = input.value.replace(/[^\d]/g, '');
    if (!digits) return;
    state.streams = clamp(parseInt(digits, 10));
    markUsed('input');
    render(false);
    fitInput();
    trackInput();
  });
  input.addEventListener('blur', function () { input.value = fmtInt.format(state.streams); });
  input.addEventListener('focus', function () { input.select(); });
  input.addEventListener('keydown', function (e) { if (e.key === 'Enter') input.blur(); });

  if (shareSel) shareSel.addEventListener('change', function () {
    state.share = (parseInt(shareSel.value, 10) || 100) / 100;
    markUsed('share');
    render(false);
  });

  // мітки повзунка 1K-10M - окреме дискретне значення (calc_quick_value), не debounce-calc_input
  root.querySelectorAll('[data-calc-quick]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.streams = clamp(parseInt(btn.getAttribute('data-calc-quick'), 10) || MIN);
      markUsed('quick');
      render(false);
      window.psTrack && psTrack('calc_quick_value', { streams: state.streams, service: state.key });
    });
  });

  // клік по рядку = цей сервіс стає відповіддю (і кнопка веде на його офер)
  Object.keys(rows).forEach(function (k) {
    rows[k].btn.addEventListener('click', function () {
      state.key = k;
      markUsed('service');
      renderSelected();
      animate();
      window.psTrack && psTrack('calc_service_select', { service: k });
    });
  });

  // ---- тултіп «?» ----
  var tip = root.querySelector('[data-calc-tip]');
  var tipBtn = root.querySelector('[data-calc-tip-btn]');
  function setTip(open) {
    if (!tip) return;
    tip.classList.toggle('is-open', open);
    tipBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  if (tipBtn) {
    tipBtn.addEventListener('click', function (e) { e.stopPropagation(); setTip(!tip.classList.contains('is-open')); });
    document.addEventListener('click', function (e) { if (!tip.contains(e.target)) setTip(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setTip(false); });
  }

  // ---- офери: трекінг + швидкий перехід (15.10.2026, власник: «повільно, нема лоадера») ----
  // href лишається /discount/<код>?redirect=<шлях з UTM> (працює без JS і в новій вкладці). З JS:
  // 1) наведення/дотик - prefetch кінцевої сторінки (рідний патерн script-list-analytics.js);
  // 2) клік - стандартний лоадер плитки (.platform-promotions__button.is-loading, як popular-categories-grid),
  //    знижку ставимо фоновим fetch /discount/... (Set-Cookie discount_code), і одразу йдемо на кінцеву сторінку
  //    (вже в кеші) - один перехід замість двох. Фолбек: fetch не встиг за 1.5 с або впав - звичайний перехід на href.
  var direct = function (a) {
    var h = a.getAttribute('href') || '', m = h.match(/\/discount\/[^?]+\?redirect=([^&]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  };
  var prefetched = {};
  var prefetch = function (a) {
    var u = direct(a) || a.getAttribute('href');
    if (!u || prefetched[u]) return;
    prefetched[u] = true;
    var l = document.createElement('link'); l.rel = 'prefetch'; l.as = 'document'; l.href = u; document.head.appendChild(l);
  };
  ['pointerenter', 'touchstart'].forEach(function (ev) {
    root.addEventListener(ev, function (e) {
      var a = e.target && e.target.closest && e.target.closest('.calc-offer-link');
      if (a) prefetch(a);
    }, ev === 'touchstart' ? { passive: true, capture: true } : true);
  });
  var clearLoading = function () {
    root.querySelectorAll('.is-loading').forEach(function (el) { el.classList.remove('is-loading'); });
  };
  window.addEventListener('pageshow', clearLoading);
  var hasDiscount = root.getAttribute('data-discount') === '1';
  // позиція серед плиток/рядків таблиці (1-based); для CTA/sticky (єдиний елемент) - 0
  function offerPosition(a, source) {
    if (source === 'tile') return Array.prototype.indexOf.call(root.querySelectorAll('.calc-tile'), a) + 1;
    if (source === 'table') return Array.prototype.indexOf.call(root.querySelectorAll('.calc__table tbody tr'), a.closest('tr')) + 1;
    return 0;
  }
  root.addEventListener('click', function (e) {
    var a = e.target.closest('.calc-offer-link');
    if (!a) return;
    markUsed('offer');
    var source = a.getAttribute('data-source') || 'row';
    var platform = a.getAttribute('data-platform') || '';
    // 18.10: один клас .calc-offer-link веде 3 офери - розрізняємо по data-source: плитка/CTA, таблиця ставок, мобільна sticky-смуга
    if (source === 'table') {
      window.psTrack && psTrack('calc_table_click', { platform: platform, position: offerPosition(a, source), streams: state.streams, discount: hasDiscount });
    } else if (source === 'sticky') {
      window.psTrack && psTrack('calc_sticky_cta', { platform: platform, streams: state.streams, discount: hasDiscount });
    } else {
      window.psTrack && psTrack('calc_offer_click', { platform: platform, position: offerPosition(a, source), streams: state.streams, discount: hasDiscount });
    }
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;
    var btn = a.querySelector('.platform-promotions__button');
    (btn || a).classList.add('is-loading');
    a.classList.add('is-loading');
    setTimeout(clearLoading, 8000);
    var href = a.getAttribute('href'), to = direct(a);
    if (!to || !window.fetch) return; // звичайний перехід
    e.preventDefault();
    // 15.10.2026: /discount у Shopify відповідає 0.7-0.95 с - НЕ чекаємо його. Одразу йдемо на кінцеву сторінку (prefetch),
    // знижку ставимо паралельно keepalive-запитом (переживає вихід зі сторінки). Страховка: тост на кінцевій сторінці
    // повторює /discount у фоні, якщо кукі discount_code не з'явилось (snippets/calc-discount-toast.liquid).
    try { sessionStorage.setItem('ps_calc_discount_href', href); } catch (er) {}
    fetch(href, { credentials: 'same-origin', redirect: 'manual', keepalive: true }).catch(function () {});
    location.href = to;
  });

  // ---- липка смуга (лише мобайл через CSS): видно, коли відповідь і офери поза екраном ----
  if (sticky && 'IntersectionObserver' in window) {
    var vis = { result: true, offers: false };
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { vis[en.target === resultBox ? 'result' : 'offers'] = en.isIntersecting; });
      var show = state.used && !vis.result && !vis.offers;
      if (show) sticky.hidden = false;
      sticky.classList.toggle('is-shown', show);
    });
    io.observe(resultBox);
    if (offersBox) io.observe(offersBox);
  }

  // ---- FAQ (#faq, акордеон спільний - assets/script-menu.js.liquid, .faq-item.toggle('active')) ----
  // calc_faq_open {index} - лише ця сторінка (скрипт вантажиться тільки на цьому шаблоні), setTimeout 0 - читаємо
  // клас ПІСЛЯ того, як відпрацював глобальний перемикач (той самий click, порядок слухачів не гарантований).
  var faqItems = document.querySelectorAll('#faq .faq-item');
  if (faqItems.length) {
    document.getElementById('faq').addEventListener('click', function (e) {
      var item = e.target.closest('.faq-item');
      if (!item) return;
      var idx = Array.prototype.indexOf.call(faqItems, item) + 1;
      setTimeout(function () {
        if (item.classList.contains('active')) window.psTrack && psTrack('calc_faq_open', { index: idx });
      }, 0);
    });
  }

  // ---- guide (#guide, SEO-текст) - calc_guide_scroll, раз на завантаження, будь-яка видимість ----
  var guide = document.getElementById('guide');
  if (guide && 'IntersectionObserver' in window) {
    var guideSeen = false;
    var guideIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting || guideSeen) return;
        guideSeen = true;
        window.psTrack && psTrack('calc_guide_scroll', {});
        guideIo.disconnect();
      });
    });
    guideIo.observe(guide);
  }

  // старт без анімації
  services.forEach(function (s) { if (rows[s.key]) rows[s.key].shown = earn(s); });
  var s0 = find(state.key); state.shownSel = s0 ? earn(s0) : 0;
  render(false);

  // calc_view - показ калькулятора, раз на завантаження сторінки (перший екран без скролу - вже у вʼюпорті)
  window.psTrack && psTrack('calc_view', {});
})();
